import { COLORS } from '../../themes/colors';
import { Theme } from '@nivo/core';

export const THEME: Theme = {
  tooltip: {
    container: {
      background: '#191c20'
    }
  },
  labels: {
    text: {
      fontWeight: 600,
      fontFamily: 'Lato'
    }
  },
  axis: {
    ticks: {
      text: {
        fill: COLORS.grey[300],
        fontFamily: 'Lato'
      }
    }
  }
};
